import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function BlogPage() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog`).then(r => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header />
      <main className="pt-24 pb-24 px-6">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-16">
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#B026FF]" style={{ fontFamily: 'Outfit, sans-serif' }}>Blog</span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-black mt-4" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="blog-heading">Blog Yazıları</h1>
            <p className="text-base sm:text-lg text-[#A1A1AA] mt-4">Eğitim dünyasından güncel yazılar ve öneriler.</p>
          </div>

          {posts.length === 0 ? (
            <div className="text-center py-20"><p className="text-[#71717A]">Henüz blog yazısı yayınlanmadı.</p></div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map(post => (
                <Link key={post._id} to={`/blog/${post._id}`} className="bg-[#0A0A0A] border border-white/10 rounded-lg overflow-hidden transition-all hover:border-[#B026FF]/50 hover:shadow-lg" data-testid={`blog-card-${post._id}`}>
                  {post.image_url && <div className="h-48 overflow-hidden"><img src={post.image_url} alt={post.title} className="w-full h-full object-cover" /></div>}
                  <div className="p-6">
                    <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>{post.title}</h3>
                    <p className="text-[#A1A1AA] text-sm line-clamp-3">{post.content?.substring(0, 150)}...</p>
                    <p className="text-[#71717A] text-xs mt-3">{new Date(post.created_at).toLocaleDateString('tr-TR')}</p>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
